// extracted by mini-css-extract-plugin
export default {"actions":"fc101f825f6eeca4","action":"a59e576b725837ec"};